/* Apply the same tracked-stock rule to native forms and lazy quick-buy drawers. */
(() => {
  const blocked = (form, id) => form?.hasAttribute('data-jovi-blocked-variants') &&
    form.getAttribute('data-jovi-blocked-variants').split(',').includes(String(id));

  // Capture runs before the native button listeners, including newly opened drawers.
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (variant && blocked(event.target, variant.id)) {
      // Do not mutate ProductLoader's cached variant: other colour selections still work.
      event.detail.variant = { ...variant, available: false };
    }
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    const id = form.querySelector?.('[name="id"]')?.value;
    if (!blocked(form, id)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.querySelectorAll('[type="submit"]').forEach(button => { button.disabled = true; });
    form.querySelectorAll('.shopify-payment-button').forEach(button => { button.style.display = 'none'; });
    let message = form.querySelector('[data-jovi-stock-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-jovi-stock-error', '');
      message.setAttribute('role', 'alert');
      form.append(message);
    }
    message.textContent = window.themeVariables?.strings?.soldOutButton || 'Out of stock';
  }, true);

  document.addEventListener('variant:change', event => {
    event.target.querySelector?.('[data-jovi-stock-error]')?.remove();
  });
})();
